import React, { useState } from "react";
import {
  Grommet,
  Box,
  Image,
  Text,
  ThemeContext,
  Button,
  Stack,
  Anchor,
} from "grommet";

import { normalizeColor } from "grommet-styles";

const theme = {
  global: {
    font: {
      family: "-apple-system, BlinkMacSystemFont, sans-serif",
      size: "18px",
      height: "20px",
    },
    colors: {
      brand: {
        dark: "#FFFFFF",
        light: "#2C2B2B",
      },
      background: {
        dark: "#2C2B2B",
        light: "#FFFFFF",
      },
      "background-front": {
        dark: "#2C2B2B",
        light: "#FFFFFF",
      },
      "background-back": {
        dark: "#2C2B2B",
        light: "#FFFFFF",
      },
    },
  },
};

type JNOState = {
  chorusI: boolean;
  chorusII: boolean;
};

export const PushButton = (props: {
  name: string;
  buttonImageSrc: string;
  LEDOn: boolean;
  clicked: () => void;
}) => (
  <Box
    direction="column"
    align="center"
    gap="0px"
    onClick={props.clicked}
    focusIndicator={false}
  >
    <div
      className={"push-button-" + props.name}
      style={{ width: 66.0, height: 66.0 }}
    ></div>
    <Stack anchor="center" style={{ width: 68.0, height: 68.0 }}>
      <Image
        src="images/push-buttons/LED On.png"
        style={{ transform: `translate(0pt, -3pt)` }}
        hidden={!props.LEDOn}
      ></Image>
      <Image src="images/push-buttons/LED Off.png" hidden={props.LEDOn}></Image>
    </Stack>
  </Box>
);

const Logo = () => (
  <div style={{ maxWidth: 420, minWidth: 220, height: "auto" }}>
    <ThemeContext.Consumer>
      {(theme) => (
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 55 15"
          preserveAspectRatio="xMidYMid meet"
          version="1.1"
        >
          <title>J_NO</title>
          <g id="Logo" fillRule="nonzero">
            <g id="J_NO" transform="translate(0.051000, 0.491000)">
              <path
                d="M11.237,10.574 C11.798,9.911 11.968,9.095 11.968,6.953 L11.968,0.17 L8.517,0.17 L8.517,6.885 C8.517,7.871 8.466,8.126 8.194,8.347 C7.888,8.636 7.225,8.738 5.916,8.738 C4.641,8.738 4.046,8.636 3.774,8.364 C3.536,8.126 3.485,7.854 3.485,6.613 L0.034,6.613 C-7.46069873e-14,7.361 -7.46069873e-14,7.48 -7.46069873e-14,7.803 C-7.46069873e-14,9.401 0.204,10.149 0.765,10.71 C1.5045,11.4166333 2.72056667,11.6625856 5.82595541,11.6781972 L6.154,11.679 C9.316,11.679 10.489,11.424 11.237,10.574 Z M21.199,14.229 L21.199,12.189 L12.699,12.189 L12.699,14.229 L21.199,14.229 Z M25.517,11.509 L25.432,3.06 L25.806,3.06 L31.773,11.509 L37.774,11.509 L37.774,0.17 L34.255,0.17 L34.34,8.619 L33.983,8.619 L28.05,0.17 L21.998,0.17 L21.998,11.509 L25.517,11.509 Z M53.567,10.897 C54.434,10.234 54.689,9.095 54.689,5.831 C54.689,2.584 54.434,1.445 53.567,0.782 C52.7,0.119 51.646,2.04281037e-14 46.903,2.04281037e-14 C42.177,2.04281037e-14 41.106,0.119 40.239,0.782 C39.4009,1.4229 39.13468,2.52448111 39.1178632,5.45343063 L39.117,5.763 C39.117,9.095 39.355,10.217 40.239,10.897 C41.0637073,11.5276585 42.0576157,11.6660958 46.2640934,11.6781012 L47.6140696,11.6781012 C51.73559,11.66574 52.74335,11.52685 53.567,10.897 Z M47.2159167,8.73774907 L46.3959668,8.73724444 C44.0088444,8.72984 43.5064,8.6632 43.078,8.33 C42.687,8.007 42.568,7.548 42.568,6.137 C42.568,3.842 42.755,3.315 43.605,3.094 C44.081,2.958 44.557,2.941 46.903,2.941 C50.099,2.941 50.49,2.992 50.847,3.485 C51.153,3.876 51.238,4.522 51.238,6.154 C51.238,7.531 51.119,8.024 50.728,8.33 C50.3012414,8.65827586 49.7477004,8.73298692 47.2159167,8.73774907 L47.2159167,8.73774907 Z"
                fill={normalizeColor("brand", theme)}
              ></path>
            </g>
          </g>
        </svg>
      )}
    </ThemeContext.Consumer>
  </div>
);

function App() {
  const [jnoState, setJNOState] = useState({ chorusI: false, chorusII: true });
  return (
    <Grommet theme={theme} themeMode="dark" full={true} cssVars={true}>
      <Stack fill={true} color="brand">
        <div className="texture-overlay"></div>
        <Box direction="row" align="center" justify="center" fill={true}>
          <Box direction="column" align="center" gap="14px" flex="grow">
            <Logo />
            <Text>Vintage Chorus Effect</Text>
            <Box direction="row" align="start" gap="12px" margin="small">
              <PushButton
                name="I"
                buttonImageSrc=""
                LEDOn={jnoState.chorusI}
                clicked={() =>
                  setJNOState({
                    chorusI: !jnoState.chorusI,
                    chorusII: jnoState.chorusII,
                  })
                }
              />
              <PushButton
                name="II"
                buttonImageSrc="images/push-buttons/Button II.png"
                LEDOn={jnoState.chorusII}
                clicked={() =>
                  setJNOState({
                    chorusI: jnoState.chorusI,
                    chorusII: !jnoState.chorusII,
                  })
                }
              />
            </Box>
            <Box direction="row" align="start" gap="12px" margin="small">
              <Anchor href="https://apps.apple.com/us/app/j-no-chorus/id1507482196">
                <Image src="images/appstore-buttons/ios-light.svg"></Image>
              </Anchor>
              <Anchor href="https://apps.apple.com/us/app/j-no-chorus/id1507482196">
                <Image src="images/appstore-buttons/macos-light.svg"></Image>
              </Anchor>
            </Box>
          </Box>
        </Box>
      </Stack>
    </Grommet>
  );
}

export default App;
